/* DaniChou Startseite v2 (Entwurf 12.10.2026): Reiter (dc-shop-by) und Duo-Warenkorb (dc-duo).
   Vanilla, ohne Abhängigkeiten, mehrfach-sicher (auch bei mehrfacher Einbindung und im Theme-Editor). */
(function () {
  'use strict';

  function initTabs(root) {
    if (root.dataset.dchReady) return;
    root.dataset.dchReady = '1';
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;
    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
    }
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(tab, false); });
      tab.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        else if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (e.key === 'Home') next = tabs[0];
        else if (e.key === 'End') next = tabs[tabs.length - 1];
        if (next) { e.preventDefault(); select(next, true); }
      });
    });
  }

  function initDuo(root) {
    if (root.dataset.dchReady) return;
    root.dataset.dchReady = '1';
    var btn = root.querySelector('[data-ids]');
    var msg = root.querySelector('[data-msg]');
    if (!btn) return;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var ids = btn.getAttribute('data-ids').split(',');
      btn.disabled = true;
      if (msg) msg.textContent = '';
      fetch(root.getAttribute('data-add') || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart');
        window.location.href = root.getAttribute('data-cart') || '/cart';
      }).catch(function () {
        btn.disabled = false;
        if (msg) msg.textContent = msg.getAttribute('data-msg');
      });
    });
  }

  function init(scope) {
    var s = scope || document;
    Array.prototype.forEach.call(s.querySelectorAll('[data-dch-tabs]'), initTabs);
    Array.prototype.forEach.call(s.querySelectorAll('[data-dch-duo]'), initDuo);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
